module.exports = __webpack_public_path__ + "media/customizations/verandaliving/back-95f3b1117d36ae287cbdfc621e6d5a98.jpg";